$(() => {
  $('[data-checked-requests-count]').on('click', function () {
    $('#checked-requests-count').text(
      $($(this).data('checked-requests-count')).length
    );
  });
});
